// extracted by mini-css-extract-plugin
module.exports = {"section":"reviews_section__1vvXq","background--contrast":"reviews_background--contrast__d8HzO","title":"reviews_title__1lt1i"};